export const VcnRoutes = {
  VCN: 'https://formation-vcn.unchk.sn/auth/oidc/',
};